<div>
  <h2>Banner</h2>
  <div>
    <h3>Banner with searchbar & button</h3>
    <vitamui-banner [searchbarPlaceholder]="'CUSTOMER.HOME.TITLE_PLACEHOLDER' | translate" [disableSearchBar]="true">
      <button class="btn primary ml-5">
        <span>Action1</span>
      </button>
    </vitamui-banner>
  </div>

  <div>
    <h3>Banner with searchbar & buttons</h3>
    <vitamui-banner [searchbarPlaceholder]="'CUSTOMER.HOME.TITLE_PLACEHOLDER' | translate" [disableSearchBar]="true">
      <button class="btn primary ml-5">
        <span>Action1</span>
      </button>
      <button class="btn primary ml-5">
        <span>Action2</span>
      </button>
      <button class="btn primary ml-5">
        <span>Action3</span>
      </button>
    </vitamui-banner>
  </div>

  <div>
    <h3>Banner with searchbar only</h3>
    <vitamui-banner [searchbarPlaceholder]="'CUSTOMER.HOME.TITLE_PLACEHOLDER' | translate" [disableSearchBar]="true"></vitamui-banner>
  </div>
</div>

<div>
  <h2>User photo with default picture</h2>
  <vitamui-common-user-photo></vitamui-common-user-photo>
</div>

<div>
  <h2>Action button menu with overlay</h2>
  <div class="gap-2">
    @for (menuButtonOutline of [false, true]; track menuButtonOutline) {
      @for (menuColor of menuColors; track menuColor) {
        <div class="d-flex hgap-2">
          <vitamui-menu-button
            [simpleOverlay]="true"
            [menuButtonOutline]="menuButtonOutline"
            [menuColor]="menuColor"
            overlayPos="start"
            icon="vitamui-icon-more-horiz"
          >
            <button mat-menu-item>Activer</button>
            <button mat-menu-item>Désactiver</button>
          </vitamui-menu-button>

          <vitamui-menu-button
            [simpleOverlay]="true"
            [menuButtonOutline]="menuButtonOutline"
            [menuColor]="menuColor"
            overlayPos="end"
            icon="vitamui-icon-more-horiz"
          >
            <button mat-menu-item>Activer</button>
            <button mat-menu-item>Désactiver</button>
          </vitamui-menu-button>

          <vitamui-menu-button
            [menuButtonOutline]="menuButtonOutline"
            [menuColor]="menuColor"
            overlayPos="start"
            icon="vitamui-icon-more-horiz"
          >
            <button mat-menu-item>Activer</button>
            <button mat-menu-item>Désactiver</button>
          </vitamui-menu-button>

          <vitamui-menu-button
            [menuButtonOutline]="menuButtonOutline"
            [menuColor]="menuColor"
            overlayPos="end"
            icon="vitamui-icon-more-horiz"
          >
            <button mat-menu-item>Activer</button>
            <button mat-menu-item>Désactiver</button>
          </vitamui-menu-button>

          <vitamui-menu-button [menuButtonOutline]="menuButtonOutline" [menuColor]="menuColor" overlayPos="end" label="With text only">
            <button mat-menu-item>Activer</button>
            <button mat-menu-item>Désactiver</button>
          </vitamui-menu-button>

          <vitamui-menu-button
            [menuButtonOutline]="menuButtonOutline"
            [menuColor]="menuColor"
            overlayPos="end"
            icon="vitamui-icon-more-horiz"
            label="With text & icon"
          >
            <button mat-menu-item>Activer</button>
            <button mat-menu-item>Désactiver</button>
          </vitamui-menu-button>
        </div>
      }
    }
  </div>
</div>

<div>
  <h2>{{ 'MISCELLANEOUS.INFINITE_SCROLL' | translate }}</h2>
  <div
    vitamuiCommonInfiniteScroll
    [vitamuiCommonInfiniteScrollThreshold]="0.5"
    [vitamuiCommonInfiniteScrollDisable]="infiniteScrollDisabled"
    (vitamuiScroll)="onScroll()"
  >
    @for (value of infiniteValues; track value) {
      <div>value {{ value }}</div>
    }
    @if (infiniteScrollDisabled) {
      <mat-spinner class="vitamui-spinner medium"></mat-spinner>
    }
  </div>
</div>
